import { useEffect } from 'react';

import type { AvailableAgent } from '@/features/scrollFlow/pages/Calendar/hooks/useAgentsAndTimeslots';
import useAppointmentStore from '@/store/AppointmentStore';

const usePreselectOriginalAgent = (
  agentsForSelectedTimeSlot: AvailableAgent[],
) => {
  const originalAgentRecordId = useAppointmentStore(
    (state) => state.confirmedAppointment?.agentInfo?.agentRecordId,
  );
  const selectedAgentRecordId = useAppointmentStore(
    (state) => state.selectedAgent?.agentRecordId,
  );
  const setSelectedAgent = useAppointmentStore(
    (state) => state.setSelectedAgent,
  );

  useEffect(() => {
    if (!originalAgentRecordId || selectedAgentRecordId) return;

    const originalAgent = agentsForSelectedTimeSlot.find(
      (agent) => agent.agentRecordId === originalAgentRecordId,
    );

    if (originalAgent) {
      setSelectedAgent(originalAgent);
    }
  }, [
    agentsForSelectedTimeSlot,
    originalAgentRecordId,
    selectedAgentRecordId,
    setSelectedAgent,
  ]);
};

export default usePreselectOriginalAgent;
